import { createSlice } from '@reduxjs/toolkit'
import {
  fetchWaterTestStripResultsAsync,
  fetchWaterTestStripResultsAsyncBuilder,
} from './asyncRequests/fetchWaterTestStripResultsAsync'
import {
  manualAnalyzeTestStripAsync,
  manualAnalyzeTestStripAsyncBuilder,
} from './asyncRequests/manualAnalyzeTestStripAsync'
import {
  uploadAndAnalyzeImageAsync,
  uploadAndAnalyzeImageAsyncBuilder,
} from './asyncRequests/uploadAndAnalyzeImageAsync'
import { WaterTestKitAnalysisResultModel, WaterTestKitAnalysisModel } from '../../types'
import { IUser } from '../../types/User'
import { WaterTestKitRequest } from '../waterTestKitRequests'
import { fetchWaterTestStripResultAsync } from './asyncRequests/fetchWaterTestStripResultAsync'



export interface WaterTestStripState {
  data: WaterTestKitAnalysisResultModel | null
  userData?: IUser | null
  jobData: WaterTestKitAnalysisModel | null
  requests: WaterTestKitRequest[]
  status: 'idle' | 'uploading' | 'processing' | 'completed' | 'failed'
  loading: boolean
  error: string | null
  success: boolean
}

export const WaterTestStripInitialState: WaterTestStripState = {
  data: null,
  userData: null,
  jobData: null,
  requests: [],
  status: 'idle',
  loading: false,
  error: null,
  success: false,
}

export const WaterTestStripSlice = createSlice({
  name: 'waterTestStrip',
  initialState: WaterTestStripInitialState,
  reducers: {
    resetWaterTestStripData: (state) => {
      return WaterTestStripInitialState
    },
  },
  extraReducers: (builder) => {
    uploadAndAnalyzeImageAsyncBuilder(builder)
    manualAnalyzeTestStripAsyncBuilder(builder)
    fetchWaterTestStripResultsAsyncBuilder(builder)
  },
})

export const WaterTestStripActions = {
  ...WaterTestStripSlice.actions,
  uploadAndAnalyzeImageAsync,
  manualAnalyzeTestStripAsync,
  fetchWaterTestStripResultAsync,
  fetchWaterTestStripResultsAsync
}

export const WaterTestStripReducer = WaterTestStripSlice.reducer
